import axios from "axios";

const PATH = "/v2/minimum-wages";

/**
 * A minimum wage and the day it is valid from. It stays valid until the next minimum wage starts.
 */
export interface MinimumWageDto {
  amount: number;
  validFrom: string;
}

interface MinimumWagesResponse {
  minimumWages: MinimumWageDto[];
}

export default {
  /**
   * Returns the minimum wage valid on the given day (`YYYY-MM-DD`), or `null` if none is.
   */
  findMinimumWage(date: string): Promise<MinimumWageDto | null> {
    return axios.get<MinimumWagesResponse>(PATH, {params: {validOn: date}})
      .then(response => response.data.minimumWages[0] ?? null);
  }
};
